import { apiClient } from "@/config/api";
import {
  Page,
  CreatePageDto,
  UpdatePageDto,
  GetPaginationPagesDto,
  PageListResponse,
} from "@/types/page";
import { ApiResponse } from "@/types/status";

const PAGE_ENDPOINTS = {
  CREATE: "/pages",
  GET_ALL: "/pages",
  GET_BY_ID: (id: string) => `/pages/${id}`,
  GET_BY_SLUG: (slug: string) => `/pages/slug/${slug}`,
  UPDATE: (id: string) => `/pages/${id}`,
  DELETE: (id: string) => `/pages/${id}`,
  CHANGE_STATUS: (id: string) => `/pages/${id}/status`,
  TOGGLE_DISPLAY: (id: string) => `/pages/${id}/toggle-display`,
} as const;

export const pageService = {
  // Tạo trang mới
  create: async (data: CreatePageDto): Promise<ApiResponse<Page>> => {
    return await apiClient.post(PAGE_ENDPOINTS.CREATE, data);
  },

  // Lấy danh sách trang với phân trang
  getPaginationPages: async (
    params: GetPaginationPagesDto
  ): Promise<ApiResponse<PageListResponse>> => {
    // Truyền thẳng params (không bọc trong { params }) để tránh ?params=[object Object]
    return await apiClient.get(PAGE_ENDPOINTS.GET_ALL, params as any);
  },

  // Lấy tất cả trang
  getAllPages: async (): Promise<ApiResponse<Page[]>> => {
    return await apiClient.get(PAGE_ENDPOINTS.GET_ALL);
  },

  // Lấy trang theo ID
  getPageById: async (id: string): Promise<ApiResponse<Page>> => {
    return await apiClient.get(PAGE_ENDPOINTS.GET_BY_ID(id));
  },

  // Lấy trang theo slug
  getPageBySlug: async (slug: string): Promise<ApiResponse<Page>> => {
    return await apiClient.get(PAGE_ENDPOINTS.GET_BY_SLUG(slug));
  },

  // Cập nhật trang
  updatePage: async (
    id: string,
    data: UpdatePageDto
  ): Promise<ApiResponse<Page>> => {
    return await apiClient.put(PAGE_ENDPOINTS.UPDATE(id), data);
  },

  // Thay đổi trạng thái trang
  changeStatus: async (
    id: string,
    status: string
  ): Promise<ApiResponse<Page>> => {
    return await apiClient.put(PAGE_ENDPOINTS.CHANGE_STATUS(id), { status });
  },

  // Toggle hiển thị trang
  toggleDisplay: async (id: string): Promise<ApiResponse<Page>> => {
    return await apiClient.put(PAGE_ENDPOINTS.TOGGLE_DISPLAY(id));
  },

  // Xóa trang
  deletePage: async (id: string): Promise<ApiResponse<void>> => {
    return await apiClient.delete(PAGE_ENDPOINTS.DELETE(id));
  },
};
